import { ShieldCheck } from "lucide-react";

export function MedicalBadge({ reviewer, date, className = "" }) {
  return (
    <div
      data-testid="medical-review-badge"
      className={`inline-flex items-center gap-2 rounded-full border border-brand/25 bg-brand/5 px-3.5 py-1.5 text-xs font-semibold text-brand ${className}`}
    >
      <ShieldCheck className="h-4 w-4 text-brand-sage" strokeWidth={2} />
      Medically Reviewed{reviewer ? ` · ${reviewer}` : ""}
      {date ? <span className="font-normal text-brand-muted">· {date}</span> : null}
    </div>
  );
}
